import { Container } from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import { statisticsStyles } from "components/statistics/styles";
import PropTypes from "prop-types";
import React from "react";

class Dashboard extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
    };
    constructor(props) {
        super(props);
    }

    render() {
        const { classes } = this.props;
        return (
            <Container maxWidth={"xl"} className={classes.tabContainer}>
                <span>dashboard</span>
            </Container>
        );
    }
}

export default withStyles(statisticsStyles)(Dashboard);
